import React from "react";
import {Cookies, CookiesProvider} from "react-cookie";
import ReactDOM from "react-dom/client";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import "./assets/css/core.css";
import Header from "./component/common/header/Header";
import Menu from "./component/common/menu/Menu";
import FaqDetail from "./component/faq/detail/Detail";
import Faq from "./component/faq/Faq";
import InquiryDetail from "./component/inquiry/detail/Detail";
import Inquiry from "./component/inquiry/Inquiry";
import Login from "./component/login/Login";
import Notice from "./component/notice/Notice";
import Write from "./component/notice/write/Write";
import * as routes from "./constants/Routes";
import reportWebVitals from "./reportWebVitals";
import Lecture from "./component/lecture/Lecture";
import Listener from "./component/lecture/listener/Listener";
import LectureDetail from "./component/lecture/detail/Detail";
import User from "./component/user/User";
import UserDetail from "./component/user/detail/Detail";
import License from "./component/license/License";
import LicenseDetail from "./component/license/detail/Detail";
import Payment from "./component/payment/Payment";
import PaymentDetail from "./component/payment/detail/Detail";
import store, {persistor} from "./redux/store";
import {Provider} from "react-redux";
import {PersistGate} from "redux-persist/integration/react";
import {setTokenValue} from "./redux/reducers/auth.reducer";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

const createToken = (name: string, value: string, options: any) => {
    const cookies = new Cookies();
    cookies.set(name, value, options);
    store.dispatch(setTokenValue(value));
};

const checkToken = () => {
    const cookies = new Cookies();
    if (cookies.get("admin_token")) {
        const token = cookies.get("admin_token");

        store.subscribe(() => {
                if (token !== store.getState().auth.tokenValue) {
                    invalidAccess();
                }
            }
        );

    } else {
        invalidAccess();
    }
};

const invalidAccess = () => {
    if (window.location.pathname !== routes.LOGIN) {
        // window.open("http://192.168.0.75:3000" + routes.LOGIN, "_self");
        window.open("https://admin.dfos.kr" + routes.LOGIN, "_self");
    }
};

checkToken();

root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
            <CookiesProvider>
                <BrowserRouter>
                    <Header/>
                    <Menu/>
                    <Routes>
                        <Route path="*" element={<div>Not Found</div>}/>
                        <Route path={routes.LOGIN} element={<Login onCreateCookie={createToken}/>}/>
                        <Route path={routes.NOTICE} element={<Notice/>}/>
                        <Route path={routes.NOTICE_WRITE} element={<Write/>}/>
                        <Route path={routes.INQUIRY} element={<Inquiry/>}/>
                        <Route path={routes.INQUIRY_DETAIL} element={<InquiryDetail/>}/>
                        <Route path={routes.FAQ} element={<Faq/>}/>
                        <Route path={routes.FAQ_DETAIL} element={<FaqDetail/>}/>
                        <Route path={routes.LECTURE} element={<Lecture/>}></Route>
                        <Route path={routes.LECTURE_LISTENER} element={<Listener/>}/>
                        <Route path={routes.LECTURE_DETAIL} element={<LectureDetail/>}/>
                        <Route path={routes.USER} element={<User/>}></Route>
                        <Route path={routes.USER_DETAIL} element={<UserDetail/>}/>
                        <Route path={routes.LICENSE} element={<License/>}/>
                        <Route path={routes.LICENSE_DETAIL} element={<LicenseDetail/>}/>
                        <Route path={routes.PAYMENT} element={<Payment/>}/>
                        <Route path={routes.PAYMENT_DETAIL} element={<PaymentDetail/>}/>
                    </Routes>
                </BrowserRouter>
            </CookiesProvider>
        </PersistGate>
    </Provider>
);

reportWebVitals();
